import { useEffect, useState } from "react";
import { api } from "../../lib/auth";

export default function AdminTransactions() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/transactions").then((r) => setRows(r.data)); }, []);

  return (
    <div data-testid="admin-transactions-page" className="p-8 lg:p-10 max-w-[1400px]">
      <h1 className="font-display font-extrabold text-4xl text-black tracking-tight">Transactions</h1>
      <p className="text-black/60 mt-1.5 text-sm">Payment activity across all tenants.</p>

      <div className="mt-7 bg-white rounded-2xl border border-black/8 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#FFFCF2] text-black/55 text-[11px] uppercase tracking-wider">
            <tr>
              <th className="text-left p-4 font-bold">Tenant</th>
              <th className="text-left p-4 font-bold">Reference</th>
              <th className="text-left p-4 font-bold">Method</th>
              <th className="text-left p-4 font-bold">Amount</th>
              <th className="text-left p-4 font-bold">Status</th>
              <th className="text-left p-4 font-bold">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-black/8">
            {rows.map((t) => (
              <tr key={t.id} className="hover:bg-[#FFFCF2]/60">
                <td className="p-4 font-semibold text-black">{t.tenant}</td>
                <td className="p-4 font-mono text-xs text-black/70">{t.reference}</td>
                <td className="p-4 text-black/70 capitalize">{(t.method || "").replace("_", " ")}</td>
                <td className="p-4 tabular-nums">₦{Number(t.amount || 0).toLocaleString()}</td>
                <td className="p-4">
                  <span className={`text-[10px] font-bold uppercase px-2 py-1 rounded-md ${
                    t.status === "verified" ? "bg-[#E8F5E9] text-[#1FA868]" : "bg-[#FFF5D6] text-amber-700"
                  }`}>{(t.status || "").replace("_", " ")}</span>
                </td>
                <td className="p-4 text-black/60 text-xs">{(t.date || "").slice(0, 10)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="6" className="p-10 text-center text-black/50">No transactions.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
